export default {

  methods: {


    async procedure_Sample() {
      // 2026-03-09 Hyeon
      // 프로젝트 로컬 데이터베이스 서버 선택 기능 추가
      // request에서 server라는 키로 구분
      // server키의 값으로는 각 프로젝트명을 소문자로 기입하면 이 키가 api에 추가되어있을 경우, 해당 프로젝트의 Local DB에 request를 전달
      // server키가 없거나 빈칸일 경우, 기존에 사용하던 Update Local DB 사용
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_SAMPLE`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        server: 'kaskida',
        name: '[K03_Planning].[dbo].[SP_Test1]',
        whereCondition: ``,
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },


    // DIAGRAM ---------------------------------------------------------------------------------------
    async dia_Select() {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_DIAGRAM_SELECT`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[DIA].[SP_SELECT]',
        whereCondition: ``,
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },


    async dia_Update(data, where) {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_DIAGRAM_UPDATE`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[DIA].[SP_UPDATE]',
        whereCondition: where,
        data: [data], //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },


    async dia_Insert(data) {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_DIAGRAM_INSERT`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[DIA].[SP_INSERT]',
        whereCondition: '',
        data: [data], //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },

    async dia_Delete(where) {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_DIAGRAM_UPDATE`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[DIA].[SP_DELETE]',
        whereCondition: where,
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },






    // STAGE ---------------------------------------------------------------------------------------
    async stg_Select() {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_STAGE_SELECT`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[STG].[SP_SELECT]',
        whereCondition: ``,
        data: [], //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },

    async stg_Update(data, where) {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_STAGE_UPDATE`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[STG].[SP_UPDATE]',
        whereCondition: where,
        data: data, //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },

    async stg_Delete(where) {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_STAGE_DELETE`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[STG].[SP_DELETE]',
        whereCondition: where,
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },







    // TABLE ---------------------------------------------------------------------------------------
    async tbl_Select() {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_TABLE_SELECT`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[TBL].[SP_SELECT]',
        whereCondition: ``,
        data: [], //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },


    async tbl_Update(data, where) {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_TABLE_UPDATE`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[TBL].[SP_UPDATE]',
        whereCondition: where,
        data: data, //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },

    async tbl_Delete(where) {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_TABLE_UPDATE`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[TBL].[SP_DELETE]',
        whereCondition: where,
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },





    // NAVIGATION ---------------------------------------------------------------------------------------
    async nav_Select() {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_NAVI_SELECT`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[NAV].[SP_SELECT]',
        whereCondition: ``,
        data: [], //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },


    // SERVICE ---------------------------------------------------------------------------------------
    async svc_Select() {
      this.cbDataReady = new Promise(resolve => {
        this.resolveCbData = resolve
      })

      const reqId = this.makeProcId ? this.makeProcId() : `${this.localId}_SERVICE_SELECT`
      const request = {
        requestId: reqId, // ?
        type: 'PROCEDURE', // ?
        name: '[KASKIDA].[SVC].[SP_SELECT]',
        whereCondition: ``,
        data: [], //insert update
      }
      if (typeof this.$emit === 'function') this.$emit('request-procedure', request)

      await this.cbDataReady
    },

  }
  
}